module.exports = __webpack_public_path__ + "img/approval-pending.893462c0.svg";